import { render, staticRenderFns } from "./TasksList.vue?vue&type=template&id=ae445724&"
import script from "./TasksList.vue?vue&type=script&lang=js&"
export * from "./TasksList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports